import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface SearchSectionProps {
	title: string;
	icon: ReactNode;
	isEmpty: boolean;
	children: ReactNode;
}

export function SearchSection({ title, icon, isEmpty, children }: SearchSectionProps) {
	const { t } = useTranslation("search");
	return (
		<div className="py-1">
			<div className="flex items-center gap-2 px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-foreground/60">
				{icon}
				<span>{title}</span>
			</div>
			{isEmpty ? <div className="px-3 py-2 text-xs text-foreground/50">{t("empty")}</div> : children}
		</div>
	);
}
